<template>
  <div class="payment-error">
    <div class="content-box">
      <img
        src="@/assets/images/notices/error-banner.png"
        alt="error-banner"
        class="banner"
      />
      <div class="error-describe">
        {{ $t("notices.pn6VR3ZYhAmlNfP5Bpm") }}
      </div>
      <div class="error-describe">
        {{ $t("notices.nk0yiYpwwTv0jcZNwLDfj") }}
      </div>
      <div class="error-describe">
        {{ $t("notices.trDgv47AxPaO7k1RlC9Z") }}
      </div>
      <div class="error-describe">
        {{ $t("notices.wccwJmmoGfq2NJqEj4u5c") }}
      </div>
      <div class="error-describe">
        {{ $t("notices.tYa3UAvyR3Zfcf7mc9OiY") }}
      </div>
      <div class="error-describe">
        {{ $t("notices.rxbeWbrLDsocsSOk0o7I8") }}<br /><br />
        {{ $t("notices.cDfNYtp6x1NxmcoVEsH3a") }}
      </div>
    </div>
    <!-- <div class="join-group-button" @click="handleJoinGroup">{{ $t('notices.epCovLaH2344wDdmyzen7') }}</div> -->
  </div>
</template>

<script>
export default {
  name: "PaymentError",
  mounted() {
    document.title = this.$t("notices.27TqFsjz0MwfQr6Zb1E");
  },
  methods: {
    handleJoinGroup() {
      window.location.href =
        "filepaxapp://filepax.com/account/pay_activity?refer_from=privileged_price_notify";
    },
  },
};
</script>

<style lang="less" scoped>
.payment-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  // height: calc(100vh - 120Px);

  // .content-box {
  // margin-top: 90Px;
  // }

  .banner {
    display: block;
    width: 154px;
    height: 110px;
    margin: 32px auto;
  }

  .error-describe {
    font-size: 17px;
    padding: 0 16px;
    margin-bottom: 24px;
  }

  .join-group-button {
    position: fixed;
    bottom: 32px;
    width: calc(100vw - 32px);
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 54px;
    background: #306eff;
    font-size: 17px;
    color: #fff;
    cursor: pointer;
    border-radius: 8px;
  }

  .date-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 16px;
  }
}
</style>
